@let conf = confirmation();

@if (conf) {
  <div class="cb-confirmation-wrapper" [ngClass]="['cb-color-' + color()]">
    <div class="cb-confirmation-overlay" (click)="selectOption(false)"></div>
    <div class="cb-confirmation-container">
      <div class="cb-confirmation-content">
        <div class="cb-confirmation-title">
          @if (conf.icon) {
            <cb-icon [name]="conf.icon"></cb-icon>
          }
          <h4>{{ conf.title | translate }}</h4>
        </div>
        <div class="cb-confirmation-message">
          <p>{{ conf.message | translate }}</p>
        </div>
      </div>
      <div class="cb-confirmation-options">
        @if (showCancelButton()) {
          <div
            class="cb-confirmation-option"
            [class.primary]="conf.dangerous"
            (click)="selectOption(false)"
          >
            <cb-icon name="cb cb-base-outline-close"></cb-icon>
            <p>{{ "COMMON.CANCEL" | translate }}</p>
          </div>
        }
        <div
          class="cb-confirmation-option"
          [class.primary]="!conf.dangerous"
          [class.with-progress]="conf.duration"
          (click)="selectOption(true)"
        >
          <cb-icon name="cb cb-base-outline-check"></cb-icon>
          <p>{{ conf.confirmText ?? "COMMON.CONFIRM" | translate }}</p>
          @if (conf.duration) {
            <div
              class="cb-confirmation-progress-bar"
              [style.width.%]="progressWidth()"
            ></div>
          }
        </div>
      </div>
    </div>
  </div>
}
